import React from 'react';
import { Card } from '../ui/card';
import { CheckCircle2, XCircle } from 'lucide-react';

const TrueFalse = ({ question, selectedAnswer, onSelectAnswer, onSelectAndSubmit, showResult }) => {
  const options = [
    { value: true, label: 'Verdadeiro' },
    { value: false, label: 'Falso' }
  ];

  const getOptionStyle = (value) => {
    const isSelected = selectedAnswer === value;
    const isCorrect = question.correct_answer === value;
    
    if (showResult) {
      if (isCorrect) {
        return 'border-green-500 bg-green-50 ring-2 ring-green-500';
      }
      if (isSelected && !isCorrect) {
        return 'border-red-500 bg-red-50 ring-2 ring-red-500';
      }
    }
    
    if (isSelected) {
      return 'border-purple-500 bg-purple-50 ring-2 ring-purple-500';
    }
    
    return 'border-gray-200 hover:border-purple-300 hover:bg-purple-25';
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {options.map((option) => (
        <Card
          key={option.label}
          className={`p-6 cursor-pointer transition-all ${getOptionStyle(option.value)} ${
            showResult ? 'cursor-default' : ''
          }`}
          onClick={() => {
            if (showResult) return;
            if (onSelectAndSubmit) {
              onSelectAndSubmit(option.value);
            } else {
              onSelectAnswer(option.value);
            }
          }}
        >
          <div className="flex flex-col items-center justify-center gap-2 py-2">
            {option.value ? (
              <CheckCircle2 className="w-12 h-12 text-green-600" />
            ) : (
              <XCircle className="w-12 h-12 text-red-600" />
            )}
            <span className="text-sm font-semibold text-gray-700">{option.label}</span>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default TrueFalse;

